function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import Bell from 'svg/bell.svg';
import styles from './MoreClinicItem.pcss';
var _React_PureComponent;
class MoreClinicItem extends (_React_PureComponent = React.PureComponent) {
    renderActiveClinicIcon() {
        const { status, clinic, organization, hasActiveNotifications } = this.props.membership;
        const { status: coStatus, name, logo } = organization || clinic || {};
        const isInactive = status !== 'Active' || coStatus !== 'Active';
        const isDeleted = coStatus === 'Deleted' || coStatus === 'Cleared';
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Avatar, {
                    avatarImg: logo,
                    name: name,
                    className: cn('sidebar__clinicLogo', styles.moreClinicItem__avatar, {
                        'sidebar__clinicLogo--deleted': isDeleted
                    }),
                    imgClassName: cn('sidebar__clinicLogo', {
                        'sidebar__clinicLogo--inactive': isInactive
                    }),
                    initialsClassName: cn({
                        'sidebar__clinicLogo--inactive': isInactive
                    })
                }),
                hasActiveNotifications && /*#__PURE__*/ _jsx("div", {
                    className: styles.moreClinicItem__notificationsBell,
                    children: /*#__PURE__*/ _jsx(Bell, {})
                })
            ]
        });
    }
    renderActiveClinicText() {
        const { clinic, organization } = this.props.membership;
        const { name } = organization || clinic || {};
        return /*#__PURE__*/ _jsx("span", {
            className: "sidebar__elementName sidebar__elementName--withOptions",
            children: name
        });
    }
    renderAvatarBadge() {
        const { status } = this.props.membership;
        const isPending = status === 'Pending';
        if (!isPending) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.moreClinicItem__avatarBadge
        });
    }
    render() {
        if (!this.props.membership) return null;
        const { clinic, organization } = this.props.membership;
        const { organizationUID, name } = organization || clinic || {};
        const clinicSlug = getSlug(name);
        const url = this.context.getUrl('general-population', {
            clinicSlug,
            organizationUID
        });
        return /*#__PURE__*/ _jsx(Link, {
            to: url,
            onClick: this.props.onClick,
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn('d-flex align-items-center justify-content-between', styles.moreClinicItem),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.moreClinicItem__avatarContainer,
                        children: [
                            this.renderActiveClinicIcon(),
                            this.renderAvatarBadge()
                        ]
                    }),
                    this.renderActiveClinicText()
                ]
            })
        });
    }
}
_define_property(MoreClinicItem, "contextType", AppContext);
_define_property(MoreClinicItem, "propTypes", {
    // Explicit props
    membership: PropTypes.shape({
        organizationUID: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        clinic: PropTypes.object,
        organization: PropTypes.object,
        hasActiveNotifications: PropTypes.bool
    }),
    onClick: PropTypes.func
});
export default withStyles(styles)(MoreClinicItem);
